import { CancelParkableTransactionMutation } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  parkableTransactionId?: number;
};

export type ConstructorArgs = {
  mutationResponse: CancelParkableTransactionMutation["cancelParkableTransaction"];
} & Partial<EventConstructorArgs>;

class CancelParkableTransactionResponse extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationResponse, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PARKABLE_TRANSACTIONS,
      type: `CANCEL_PARKABLE_TRANSACTION.RESPONSE`,
      data: {
        parkableTransactionId: mutationResponse?.parkableTransaction?.id,
      },
    });
  }
}

export { CancelParkableTransactionResponse };
